import api from './apiConfig';

const processService = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/processes', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching processes:', error);
      throw error;
    }
  },

  getProcessesByCodexType: async (codexTypeId) => {
    try {
      const response = await api.get(`/processes?codexTypeId=${codexTypeId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching processes by codex type:', error);
      throw error;  
    }
  },

  getLastCodexProcessByCodexId: async (codexId) => {
    try {
      const response = await api.get('/codex-processes', {
        params: {
          page: 0,
          size: 1,
          sort: 'createdAt,desc',
          codexId: codexId
        }
      });
      return response.data.content && response.data.content.length > 0 ? response.data.content[0] : null;
    } catch (error) {
      console.error('Error fetching last process by codex id:', error);
      throw error;
    }
  },

  getById: async (id) => {
    try {
      const response = await api.get(`/processes/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching process ${id}:`, error);
      throw error;
    }
  },

  create: async (data) => {
    try {
      const response = await api.post('/processes', data, {headers:{"Content-type": "multipart/form-data",}});
      return response.data;
    } catch (error) {
      console.error('Error creating process:', error);
      throw error;
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`/processes/${id}`, data, {headers:{"Content-type": "multipart/form-data",}});
      return response.data;
    } catch (error) {
      console.error(`Error updating process ${id}:`, error);
      throw error;
    }
  },

  delete: async (id) => {
    try {
      const response = await api.delete(`/processes/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting process ${id}:`, error);
      throw error;
    }
  },

  deploy: async (id) => {
    try {
      const response = await api.post(`/processes/${id}/deploy`);
      return response.data;
    } catch (error) {
      console.error(`Error deploying process ${id}:`, error); 
      throw error;
    }
  },

  startCodexProcess: async (codexId, processId, variables = {}) => {
    let processResponse;
    try {
      const resultMessage = {
        processId: processId,  // This is the process type ID
        codexId: codexId
      };

      const response = await api.post('/codex-processes', resultMessage);
      processResponse = response.data;
    } catch (error) {
      throw new Error('Errore nella creazione del processo: ' + error.message);
    }
    return processResponse;
  },

  restartCodexProcess: async (codexId, processId, variables = {}) => {
    let processResponse;
    try {
      const resultMessage = {
        processId: processId,  // This is the process type ID
        codexId: codexId
      };

      const response = await api.post('/codex-processes/restart', resultMessage);
      processResponse = response.data;
    } catch (error) {
      throw new Error('Errore nel riavvio del processo: ' + error.message);
    }
    return processResponse;
  },

  getAllProcessesTypes: async () => {
    try {
      const response = await api.get('/processes/types');
      return response.data;
    } catch (error) {
      console.error('Error fetching process types:', error);
      throw error;
    }
  }
};

export default processService;